import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";
import { navigator } from "@hotwired/turbo";

export default class BaseRailsRequestController extends Controller {
  showProgressBar() {
    navigator.delegate.adapter.progressBar.setValue(0);
    navigator.delegate.adapter.progressBar.show();
  }

  hideProgressBar() {
    navigator.delegate.adapter.progressBar.setValue(1);
    navigator.delegate.adapter.progressBar.hide();
  }

  withProgress(promise) {
    this.showProgressBar();

    return promise.finally(() => {
      this.hideProgressBar();
    });
  }

  fetchWithProgress(method, url, options = {}) {
    const request = new FetchRequest(method, url, options);
    return this.withProgress(request.perform());
  }
}
